module.exports = __webpack_public_path__ + "media/illustrations/empty_search-42867f27.png";